import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { AppearanceService } from 'src/app/services/appearance/appearance.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-navbar-menu',
  templateUrl: './navbar-menu.component.html',
  styleUrls: ['./navbar-menu.component.scss'],
})
export class NavBarMenuComponent implements OnInit {


  constructor(public popoverCtrl: PopoverController, public userService: UserService, public appearanceService: AppearanceService) { 

  }

  ngOnInit() {}


  selectMode(mode)
  {
    this.popoverCtrl.dismiss({ route: mode });
  }
  

}
